/* eslint-disable no-unused-vars */
// src/utils/tiktok.js
/* global ttq */
function initTiktokPixel(pixelId) {
    if (window.ttq) return; // 防止重复加载

    !function(w, d, t) {
        w.TiktokAnalyticsObject = t;
        var ttq = w[t] = w[t] || [];  // 这里定义的 ttq 用于内部函数

        ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie", "holdConsent", "revokeConsent", "grantConsent"];

        ttq.setAndDefer = function(t, e) {
            t[e] = function() {
                t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
            };
        };

        for (var i = 0; i < ttq.methods.length; i++) {
            ttq.setAndDefer(ttq, ttq.methods[i]);
        }

        ttq.load = function(e) {
            var r = "https://analytics.tiktok.com/i18n/pixel/events.js";
            ttq._i = ttq._i || {};
            ttq._i[e] = [];
            ttq._i[e]._u = r;
            ttq._t = ttq._t || {};
            ttq._t[e] = +new Date;
            ttq._o = ttq._o || {};

            var n = document.createElement("script");
            n.type = "text/javascript";
            n.async = true;
            n.src = r + "?sdkid=" + e + "&lib=" + t;
            var firstScript = document.getElementsByTagName("script")[0];
            firstScript.parentNode.insertBefore(n, firstScript);
        };

        ttq.load(pixelId);  // 使用传入的 Pixel ID
        ttq.page();  // 触发 page 事件
    }(window, document, 'ttq');
}

export { initTiktokPixel };
